// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {RecordingSegment} from './recording-segment.js'

export class ModifyRecording {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyRecording {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyRecording(bb: flatbuffers.ByteBuffer, obj?: ModifyRecording): ModifyRecording {
    return (obj || new ModifyRecording()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyRecording(bb: flatbuffers.ByteBuffer, obj?: ModifyRecording): ModifyRecording {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyRecording()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  recording(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  name(): string | null
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  segmentation(index: number, obj?: RecordingSegment): RecordingSegment | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new RecordingSegment()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 16, this.bb!)
      : null
  }

  segmentationLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  static startModifyRecording(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addRecording(builder: flatbuffers.Builder, recordingOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, recordingOffset, 0)
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0)
  }

  static addSegmentation(builder: flatbuffers.Builder, segmentationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, segmentationOffset, 0)
  }

  static startSegmentationVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(16, numElems, 8)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(3, zIndex, null)
  }

  static endModifyRecording(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // recording
    return offset
  }

  static createModifyRecording(
    builder: flatbuffers.Builder,
    recordingOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    segmentationOffset: flatbuffers.Offset,
    zIndex: bigint | null
  ): flatbuffers.Offset {
    ModifyRecording.startModifyRecording(builder)
    ModifyRecording.addRecording(builder, recordingOffset)
    ModifyRecording.addName(builder, nameOffset)
    ModifyRecording.addSegmentation(builder, segmentationOffset)
    if (zIndex !== null) ModifyRecording.addZIndex(builder, zIndex)
    return ModifyRecording.endModifyRecording(builder)
  }
}
